var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseErrorIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16,
    r: 15.5,
    stroke: "#FF3E6C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.78 9.28a.958.958 0 011.356 0l5.072 5.073 5.073-5.072a.958.958 0 011.355 1.355l-5.072 5.072 5.072 5.073a.958.958 0 01-1.355 1.355l-5.073-5.072-5.072 5.072a.958.958 0 01-1.355-1.355l5.072-5.073-5.072-5.072a.958.958 0 010-1.355z",
    fill: "#FF3E6C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseErrorIcon);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzMiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMyAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTYuNSIgY3k9IjE2IiByPSIxNS41IiBzdHJva2U9IiNGRjNFNkMiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05Ljc4MDY5IDkuMjgwNjlDMTAuMTU0OSA4LjkwNjQ0IDEwLjc2MTcgOC45MDY0NCAxMS4xMzYgOS4yODA2OUwxNi4yMDgzIDE0LjM1M0wyMS4yODA3IDkuMjgwNjlDMjEuNjU0OSA4LjkwNjQ0IDIyLjI2MTcgOC45MDY0NCAyMi42MzYgOS4yODA2OUMyMy4wMTAyIDkuNjU0OTQgMjMuMDEwMiAxMC4yNjE3IDIyLjYzNiAxMC42MzZMMTcuNTYzNiAxNS43MDgzTDIyLjYzNiAyMC43ODA3QzIzLjAxMDIgMjEuMTU0OSAyMy4wMTAyIDIxLjc2MTcgMjIuNjM2IDIyLjEzNkMyMi4yNjE3IDIyLjUxMDIgMjEuNjU0OSAyMi41MTAyIDIxLjI4MDcgMjIuMTM2TDE2LjIwODMgMTcuMDYzNkwxMS4xMzYgMjIuMTM2QzEwLjc2MTcgMjIuNTEwMiAxMC4xNTQ5IDIyLjUxMDIgOS43ODA2OSAyMi4xMzZDOS40MDY0NCAyMS43NjE3IDkuNDA2NDQgMjEuMTU0OSA5Ljc4MDY5IDIwLjc4MDdMMTQuODUzIDE1LjcwODNMOS43ODA2OSAxMC42MzZDOS40MDY0NCAxMC4yNjE3IDkuNDA2NDQgOS42NTQ5NCA5Ljc4MDY5IDkuMjgwNjlaIiBmaWxsPSIjRkYzRTZDIi8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };